module.exports = __webpack_public_path__ + "img/DK20273801.e5bb3fff.png";